/**
 * Created by fers on 27.04.16.
 */
import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, IntlShape} from 'react-intl';
import {Tooltip, OverlayTrigger} from 'react-bootstrap';
import {viewWithDataGetPrimaryData} from '../../box-utils/PrimaryData';
import Error from './Error.react.js';
import {default as JSONTable} from './JSONTable';
import {sendError} from '../../../app/errorDisplayer';
import Grid from '../../../fw/Grid.react.js';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import {relayWrap} from '../../box-utils/ParentBox.react.js';
import openScreenSettings from '../../screen-settings/openScreenSettings';
import urlMapping from '../../../app/URLMapping';
import {lastPanelController} from '../../EmbededPanelController';
import OPENERS from '../../screen-settings/WidgetConfigOpeners';
import * as FeatureFlags from '../../../../common/util/FeatureFlags.ts';
import {Link} from 'react-router';
import {getLocale} from '../../../locales';

import './JSONTable.scss';
import * as BrowserPermission from "../../../BrowserPermission";
import {safeJSONparse} from "../../../../common/util/safeJSONparse";

export const JSON_TABLE_NEW_COLUMN_COUNT = 10;

export class JSONTableNew extends JSONTable {

    static handlerName = "json-table";

    static propTypes = {
		isConfigurable: PropTypes.bool,
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    static contextTypes = {
        router: PropTypes.object,
    };

	static defaultProps = {
		isConfigurable: true
	};

	constructor(props) {
		super(props);
	}

	getColumnsFromViewDef() {
		return JSONTableNew.getColumnsFromViewDefStatic(this.props);
	}

	static getSortingClassName(asc) {
		return "sorting " + (asc ? 'asc' : 'desc');
	}

	static getUrlInternal = (props, item, column) => {
        if (!column || !item) {
            return;
        }

        let {addon} = props.viewWithData;
        addon = safeJSONparse(addon);

        if (addon && addon['links'] && addon['links'][item.key]) {
            let url = addon['links'][item.key];

            if (url[column]) {
                return url[column];
            }
        }
    };

	static getTooltip(item, isPreview) {
		let appName = 'CRM';

		if (isPreview) {
			return (<Tooltip id="jsonTableTooltip"><FormattedMessage defaultMessage="Link to connected application detail page" id="jsonTable.previewTooltip" values={{app: appName}}/></Tooltip>);
		}

		if (item && item.channel) {
			return (<Tooltip id="jsonTableTooltip"><FormattedMessage defaultMessage="Open {app} detail" id="jsonTable.openTooltip" values={{app: item.channel}}/></Tooltip>);
		}

		return (<Tooltip id="jsonTableTooltip"><FormattedMessage defaultMessage="Open in application detail" id="jsonTable.openDefaultTooltip" /></Tooltip>);
	}

	static renderDativeryLinks(column, item) {
		let out = [];
		let urls;
		let idx = 0;

		if (FeatureFlags.hasFeatureFlag(FeatureFlags.FEATURE_DASHBOARD, BrowserPermission.getPermissionObject())) {
			urls = JSONTableNew.getUrlInternal(this.props, item, 'dativery');
			if (urls) {
                for (let u of urls) {
                    let url = u.href;
                    if (url) {
                        /* absolute links are href, others or <Link /> */
                        if (url.startsWith("http://") || url.startsWith("https://")) {
                            out.push(<a href={url} key={idx++} target="_blank">
                                <span className="fa fa-puzzle-piece fa-flip-horizontal"></span>
                            </a>);
                        } else {
                            out.push(<Link key={idx++} to={url}>
                                <span className="fa fa-puzzle-piece fa-flip-horizontal"></span>
                            </Link>);
                        }
                        out.push(<span key={idx++}>&nbsp; &nbsp;</span>);
                    }
                }
			}
		}

		urls = JSONTableNew.getUrlInternal(this.props, item, '*') || [];
		if (this.props.isPreview) {
			urls = [{href: "#"}];
		}
        if (urls) {
            for (let u of urls) {
                let url = u.href;

                if (url) {
                    let tooltip = JSONTableNew.getTooltip({...item, ...u}, this.props.isPreview);
                    out.push(
                        <OverlayTrigger key={idx++} overlay={tooltip} placement="top">
                            <a href={url} target="_blank"><span className="fa fa-search"></span></a>
                        </OverlayTrigger>
                    );
                }
            }
        }

		return out;
	}

	// to be abble conditionaly override it from child
	static getColumnsFromViewDefStatic(props, filterOutNotExistingColumns = true) {
		let template = props.viewWithData.view.template || (props.viewWithData.view.entityViewDef ? props.viewWithData.view.entityViewDef.template : null) || '[]';
		let order = props.viewWithData.view.order || (props.viewWithData.view.entityViewDef ? props.viewWithData.view.entityViewDef.order : null) || '[]';
		let fields = template ? safeJSONparse(template) : [];
		let sorting = order ? safeJSONparse(order) : [];
		let templateColumns = {};

		let sortingId = sorting && sorting.length > 0 ? sorting[0].column : null;

		if (filterOutNotExistingColumns) {
            let mappedFields = [];

            if (props.viewWithData.dataSource && props.viewWithData.dataSource.mappedFields) {
                mappedFields = props.viewWithData.dataSource.mappedFields;
            } else if (props.viewWithData.entityDef && props.viewWithData.entityDef.allFieldDefs && props.viewWithData.entityDef.allFieldDefs.edges) {
                mappedFields = props.viewWithData.entityDef.allFieldDefs.edges.map(({node}) => node);
            }

			fields = fields.filter(field => {
                if (field.id === "organisation" || field.id === "channel") {
                    return true;
                }

				return -1 !== mappedFields.findIndex(mappedField => mappedField.realId === field.id);
			});
		}

		fields.forEach(field => {
			let column = {};

			if (sortingId && sortingId === field.id) {
				column.className = JSONTableNew.getSortingClassName(sorting[0].asc);
			}

			if (field.name) {
				if (typeof field.name === 'object' && field.name[getLocale()]) {
					column.name = field.name[getLocale()];
				}
				else {
					column.name = field.name;
				}
			}

			templateColumns[field.id] = column;
		});

		if (!props.widgetConfigView) {
			templateColumns['dativery'] = {
				className: 'dativeryLinks',
				render: JSONTableNew.renderDativeryLinks.bind({props: props})
			};
		}
		else {
			delete templateColumns.dativery;
		}

		return templateColumns;
	}

	getPreviewData(rows) {
		rows = rows || 2;

		if (this.previewData && rows === this.rows) {
			return this.previewData;
		}

		this.rows = rows;
		this.previewData = [];

		/* we want to render two rows of data */
        if (this.props.viewWithData.entityDef && this.props.viewWithData.entityDef.allFieldDefs) {
            let exampleRow = {};

            for (let field of this.props.viewWithData.entityDef.allFieldDefs.edges) {
                if (field.node.exampleData) {
                    exampleRow[field.node.realId] = field.node.exampleData;
                }
            }

			for (let i = 0; i < rows; i++) {
				this.previewData.push({
					key: '' + i,
					...exampleRow
				});
			}
        }
		else {
			for (let i = 0; i < rows; i++) {
				this.previewData.push({
					key: '' + i
				});
			}
			this.previewData = [{key: '1'}, {key: '2'}];
		}
		return this.previewData;
	}

	static getLimit(viewWithData) {
		try {
			let filter = viewWithData.view.filter ? safeJSONparse(viewWithData.view.filter) : null;

			if (!filter || !filter.limit) {
				filter = viewWithData.view.entityViewDef.filter ? safeJSONparse(viewWithData.view.entityViewDef.filter) : null;
			}

			return filter.limit || JSON_TABLE_NEW_COLUMN_COUNT;
		}
		catch (e) {
			// ignore error and fallback to default count
		}

		return JSON_TABLE_NEW_COLUMN_COUNT;
	}

	getData(rowCount) {
        let data = viewWithDataGetPrimaryData(this.props.viewWithData);

		return data.slice(0, rowCount);
	}

	gotoConfigureTable() {
		if (this.props.isPreview) {
			return;
		}

		let urlObject = lastPanelController().getURLObject();
		urlObject.viewId = this.props.viewWithData.view.realId;
		urlObject.opener = OPENERS.PANEL;

		let path = urlMapping.getUrl("panel", "widget-config", urlObject);

		openScreenSettings(this.context.router, path);
	}

    render() {
		let rowCount = JSONTableNew.getLimit(this.props.viewWithData);
		let data = this.props.isPreview ? this.getPreviewData(rowCount) : this.getData(rowCount);

		const tooltip = (
			<Tooltip id="tooltip"><FormattedMessage defaultMessage="Add/remove columns in the final table added to panel." id="jsonTable.configurableInfoNew" /></Tooltip>
		);

		const configurableLink = <a onClick={this.gotoConfigureTable.bind(this)}><i className="fa fa-pencil"></i> <FormattedMessage defaultMessage="Configure table" id="jsonTable.configureTable" /></a>;

        try {
            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <small className="jsonTable jsonTableNew">
						<Grid columns={this.getColumnsFromViewDef()}
							getUrl={this.getUrl}
							list={data}
							metadata={this.getMetaData()}
							render={this.props.isPreview ? this.renderPreview : null}
						/>
						{this.props.isConfigurable ?
							<div className="configureJsonTable flex-row">
								{data.length >= rowCount
									? <span className="excerptMessage"><FormattedMessage defaultMessage="Displayed first {count} records" id="jsonTable" values={{count: rowCount}} /></span>
									: null
								}
								<span className="flex"></span>
								{this.props.isPreview
									? (<OverlayTrigger overlay={tooltip} placement="bottom">
											{configurableLink}
										</OverlayTrigger>)
									: configurableLink
								}
							</div>
						: null }
					</small>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(JSONTableNew);
